import { useState, useEffect } from 'react'

function useIsTabActive() {
  const [isPageActive, setIsPageActive] = useState(!document.hidden)
  useEffect(() => {
    const visibilityChangeHandler = () => {
      setIsPageActive(!document.hidden)
    }

    document.addEventListener('visibilitychange', visibilityChangeHandler)

    return () => {
      document.removeEventListener('visibilitychange', visibilityChangeHandler)
    }
  }, [])

  return [isPageActive]
}

export default useIsTabActive
